export default {
      id: "title-real-estate-usage",
      viewBox: "0 0 172 14",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#title-real-estate",
      toString: function () {
        return this.url;
      }
    }